var _g, _path, _path2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvidentPrimaryLogoBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1479.6 2033.9",
    style: {
      enableBackground: "new 0 0 1479.6 2033.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M975.6,0H182.3h-2H0v474.5l0,24.1v1535.3h1479.6V504C1479.6,225.6,1275.3,0,975.6,0z M1391.3,1939.5H90.7V90.1h892.2 c225.6,0,408.4,182.9,408.4,408.4V1939.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M282.6,1484.8v92.3h240.5v84.5H282.6v96.2h260v91H181.8v-455h360.7v91H282.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M946.2,1507.6l-117,341.2H688.8l-117-341.2h97.5l89.7,261.3l89.7-261.3H946.2z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1068.2,1757.9h-93.1v90.9h124v-60C1099.2,1771.7,1085.3,1757.9,1068.2,1757.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvidentPrimaryLogoBlack);
export default __webpack_public_path__ + "static/media/Evident-Primary Logo-Black.2012fb9d468f1d8cffaaf1f25b806bbe.svg";
export { ForwardRef as ReactComponent };